module.exports = __webpack_public_path__ + "static/media/google.2873116c.svg";